import type { ApolloClient } from "@apollo/client";
import type { Dispatch } from "redux";

import { accountConstants } from "./types";
import { accountService } from "services/accountService";
import ActionCreator from "utils/actionHandler";

export const getAllAccounts = (client: ApolloClient<object>) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof accountService.getUserAccounts>>
    >(accountConstants.GET_ACCOUNTS);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      accountService.getUserAccounts(client)
    );
  };
};

export const getIraAccountBalance = (
  client: ApolloClient<object>,
  iraAccountId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof accountService.getIraAccountBalanceRequest>>
    >(accountConstants.GET_IRA_BALANCE);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      accountService.getIraAccountBalanceRequest(client, iraAccountId)
    );
  };
};

export const setAccountSession = (
  client: ApolloClient<object>,
  accountId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof accountService.setAccountSession>>
    >(accountConstants.SET_ACCOUNT_SESSION);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      accountService.setAccountSession(client, accountId)
    );
  };
};

export const setAccountForClose = (accountId: string, accountType: string) => ({
  type: "SET_ACCOUNT_FOR_CLOSE",
  payload: {
    accountId,
    accountType,
  },
});

export const setAccountPendingClosure = (
  accountId: string,
  accountType: string
) => ({
  type: "SET_ACCOUNT_PENDING_CLOSURE",
  payload: { accountId, accountType },
});
